import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-overige-vragen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-overige-vragen.component.html',
  styleUrl: './tekst-overige-vragen.component.scss',
})
export class TekstOverigeVragenComponent {}
